import Plans from '../../../../core/constants/plans';

export const ModeratedSettingsFormatted = {
  zoom_api: 'Zoom API',
  custom: 'Custom',
};

const PlansFormatted = {
  PAY_AS_YOU_GO: 'Pay as you go',
  SCALE: 'Scale',
  GROW: 'Grow',
};

export const planOptions = [
  {
    key: Plans.PAY_AS_YOU_GO,
    text: PlansFormatted.PAY_AS_YOU_GO,
    value: Plans.PAY_AS_YOU_GO,
  },
  {
    key: Plans.SCALE,
    text: PlansFormatted.SCALE,
    value: Plans.SCALE,
  },
  {
    key: Plans.GROW,
    text: PlansFormatted.GROW,
    value: Plans.GROW,
  },
];

const CustomerType = {
  SIGNATURE: 'signature',
  PREMIER: 'premier',
  GENERAL_BUSINESS: 'general_business',
  PAY_AS_YOU_GO: 'pay_as_you_go',
  PILOT: 'pilot',
};

const CustomerTypeFormatted = {
  SIGNATURE: 'Signature',
  PREMIER: 'Premier',
  GENERAL_BUSINESS: 'General business',
  PAY_AS_YOU_GO: 'Pay as you go',
  PILOT: 'Pilot',
};

export const customerTypeOptions = [
  {
    key: CustomerType.SIGNATURE,
    text: CustomerTypeFormatted.SIGNATURE,
    value: CustomerType.SIGNATURE,
  },
  {
    key: CustomerType.PREMIER,
    text: CustomerTypeFormatted.PREMIER,
    value: CustomerType.PREMIER,
  },
  {
    key: CustomerType.GENERAL_BUSINESS,
    text: CustomerTypeFormatted.GENERAL_BUSINESS,
    value: CustomerType.GENERAL_BUSINESS,
  },
  {
    key: CustomerType.PAY_AS_YOU_GO,
    text: CustomerTypeFormatted.PAY_AS_YOU_GO,
    value: CustomerType.PAY_AS_YOU_GO,
  },
  {
    key: CustomerType.PILOT,
    text: CustomerTypeFormatted.PILOT,
    value: CustomerType.PILOT,
  },
];
